import { Pageable } from '@models/common.model';

export enum NotificationStatusEnum {
    UnRead = 0,
    Read,
    Deny,
    Allow,
}

export enum NotificationTypeEnum {
    Alert = 1,
    Interact,
    Discount,
}

export enum NotificationActionEnum {
    OrderDetail = 'OrderDetail',
    CreateOrder = 'CreateOrder',
}

export interface NotificationSearchParam extends Pageable {
    user_id?: number;
}

export interface NotificationModel {
    NotificationId: number;
    TypeNotification: number;
    TypeNotificationName: string;
    NotificationUserId: number;
    Title: string;
    Content: string;
    Status: number;
    Action: string;
    DataJson?: string;
    Data?: NotificationData;
    TimeStartNotification: string;
    CreatedDate: string;
    CreatedBy: number;
    CreatedByCode: string;
    CreatedByName: string;
    ModifiedDate: string;
    ModifiedBy: number;
    ModifiedByCode?: string;
    ModifiedByName?: string;
    TimeSpanNotificaion: string;
}

export interface NotificationData {
    TransactionId: string;
}

export interface CountNotifyItemResponse {
    TotalItemUnRead: number;
}

export interface ChangeStatusNotification {
    ListNotificationId: number[];
    Status: number;
}

export type NotificationInteractReq = Pick<
    NotificationModel,
    'NotificationId' | 'Status' | 'Action'
>;
